export const BRAND_CENTER_PATH = '/brand/voice';
export const BRAND_SOURCES_PATH = '/brand/sources';
